import { select, SelectEffect } from "redux-saga/effects";

import { RootState } from "@types-runway/state";

export function selectState<T>(selector: (s: RootState) => T): SelectEffect {
  return select(selector);
}
